import PropTypes from 'prop-types';

import Box from 'shopper/components/Box';
import Heading from 'shopper/components/Heading';
import Text from 'shopper/components/Text';

import Image from 'components/Image';
import UserAvatar from 'components/UserAvatar';

import { sendEvent } from 'lib/gtag';
import placeholder from 'lib/placeholder';

import StatsItem from './StatsItem';

import APP from 'constants/app';

const toFormattedStatString = (qtd, [plural, singular]) =>
  qtd === 1 ? singular : plural;

const toFormattedCommentsAndReviewsWritten = (qtd) =>
  toFormattedStatString(qtd, [
    'reviews ou comentários',
    'review ou comentário',
  ]);

const toFormattedOffersAndCouponsSent = (qtd) =>
  toFormattedStatString(qtd, ['ofertas ou cupons', 'oferta ou cupom']);

const toFormattedThreadsSent = (qtd) =>
  toFormattedStatString(qtd, ['tópicos no fórum', 'tópico no fórum']);

const Stats = ({
  gaEventCategory,
  stats: {
    userCommentsWritten,
    userCommunityHelp,
    userCouponsSent,
    userOffersSent,
    userReviewsWritten,
    userThreadsSent,
  } = {
    userCommentsWritten: 0,
    userCommunityHelp: 0,
    userCouponsSent: 0,
    userOffersSent: 0,
    userReviewsWritten: 0,
    userThreadsSent: 0,
  },
}) => {
  const commentsAndReviewsWritten = userCommentsWritten + userReviewsWritten;
  const offersAndCouponsSent = userCouponsSent + userOffersSent;

  const onMouseOver = () => {
    sendEvent({ category: gaEventCategory, action: 'scorebar_hover' });
  };

  return (
    <Box
      className="relative mt-6 flex-row overflow-x-scroll rounded-r-1 px-2 py-4 md:mt-10 md:rounded-r-2 lg:overflow-visible"
      full
    >
      <StatsItem tooltipText="Consideramos curtidas da comunidade como sinal de que a oferta, comentário, tópico ou review foi relevante e ajudou os membros.">
        <>
          {/* eslint-disable-next-line jsx-a11y/mouse-events-have-key-events */}
          <div className="flex items-center" onMouseOver={onMouseOver}>
            <UserAvatar size="size3" />
            <UserAvatar className="-ml-4" size="size3" />
          </div>
          <div className="ml-4">
            <Text size="size2">{placeholder('subtitles.helpedCommunity')}</Text>
            <Heading
              className="inline text-primary-300 dark:text-primary-300"
              size="size5"
            >
              {userCommunityHelp}
            </Heading>
            <Text className="ml-1 inline" size="size2">
              vezes
            </Text>
          </div>
        </>
      </StatsItem>
      <StatsItem>
        <Image
          alt="Ícone de comentários"
          height={46}
          src={`${APP.LOCAL_IMAGE_PATH}/features/user-profile/comments.svg`}
          width={50}
        />
        <div className="ml-4">
          <Text className="inline" size="size2">
            Escreveu
          </Text>
          <Heading
            className="ml-1 inline text-primary-300 dark:text-primary-300"
            size="size5"
          >
            {commentsAndReviewsWritten}
          </Heading>
          <Text size="size2">
            {toFormattedCommentsAndReviewsWritten(commentsAndReviewsWritten)}
          </Text>
        </div>
      </StatsItem>
      <StatsItem>
        <Image
          alt="Ícone de ofertas"
          height={50}
          src={`${APP.LOCAL_IMAGE_PATH}/features/user-profile/offers.svg`}
          width={33}
        />
        <div className="ml-4">
          <Text className="inline" size="size2">
            Enviou
          </Text>
          <Heading
            className="ml-1 inline text-primary-300 dark:text-primary-300"
            size="size5"
          >
            {offersAndCouponsSent}
          </Heading>
          <Text size="size2">
            {toFormattedOffersAndCouponsSent(offersAndCouponsSent)}
          </Text>
        </div>
      </StatsItem>
      <StatsItem className="border-r-0">
        <Image
          alt="Ícone de tópicos"
          height={46}
          src={`${APP.LOCAL_IMAGE_PATH}/features/user-profile/threads.svg`}
          width={50}
        />
        <div className="ml-4">
          <Text className="inline" size="size2">
            Criou
          </Text>
          <Heading
            className="ml-1 inline text-primary-300 dark:text-primary-300"
            size="size5"
          >
            {userThreadsSent}
          </Heading>
          <Text size="size2">{toFormattedThreadsSent(userThreadsSent)}</Text>
        </div>
      </StatsItem>
    </Box>
  );
};

Stats.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  stats: PropTypes.shape({
    userCommentsWritten: PropTypes.number,
    userCommunityHelp: PropTypes.number,
    userCouponsSent: PropTypes.number,
    userOffersSent: PropTypes.number,
    userReviewsWritten: PropTypes.number,
    userThreadsSent: PropTypes.number,
  }),
};

export default Stats;
